module.exports = __webpack_public_path__ + "img/20.039b425c.png";